import { Grid, MenuItem, Select, TextField } from "@material-ui/core";
import { questionTypeSetup, questionTypes, vehicleDetailTypes, vehicleFieldsToMap, vehicleFieldsToMapSetup } from "../formBuilderConsts";
import { FormBuilderStyles } from "../style";
import DropdownFilter from "components/DropdownFilter";
import { vehicleDetailExtendedDate, vehicleDetailExtendedMulti, vehicleDetailExtendedValues } from "features/vehicles/VehicleDetailExtended/VehicleDetailExtendedTypes";
import { vehicleFieldsValues } from "features/Forms/formBuilder/formBuilderConsts";
import { orderBy, debounce, get } from "lodash";
import { useCallback, memo, useState, useEffect, useMemo } from "react";
import { useGetExtendedFieldTypesQuery, useGetImageTypesQuery } from "features/vehicles/vehicleSlice";
import { arrayToObject } from "utils/object-util";



const FormQuestion = ({ form, question, onChange, mappedFieldsUsed }) => {

    const classes = FormBuilderStyles();
    const [localQuestion, setLocalQuestion] = useState(question?.question || "");
    let { data: vdExtended, error: fieldsError, isLoading: isLoadingFields } = useGetExtendedFieldTypesQuery();

    const vdExtendedLookup = arrayToObject(vdExtended ?? []);

    useEffect(() => {
        setLocalQuestion(question?.question || "");
    }, [question?.question]);

    const debouncedUpdate = useMemo(() => debounce((value) => {
        onChange({ ...question, question: value });
    }, 500), [onChange, question]);

    useEffect(() => {
        return () => debouncedUpdate.cancel();
    }, [debouncedUpdate]);

    const QuestionComponent = questionTypeSetup[question?.questionType]?.component;

    const couldMapToField = question?.questionType !== questionTypes.Image;

    const getImageType = (mapToFieldType, mappedToField) => {
        if (mapToFieldType == vehicleDetailTypes.vehicleDetailExtended) {
            return vdExtendedLookup?.[mappedToField]?.imageTypeId;
        }
        return question?.mappedToImageType;
    }
    const getQuestionType = (mapToFieldType, mappedToField, newQuestionType) => {
        if (mapToFieldType == vehicleDetailTypes.vehicleDetailExtended && vehicleDetailExtendedValues?.[mappedToField]?.length) {
            if (vehicleDetailExtendedMulti?.[mappedToField]) {
                return questionTypes.MultipleChoice;
            }
            else {
                return questionTypes.Dropdown;
            }
        } else if (mapToFieldType == vehicleDetailTypes.vehicle && vehicleFieldsValues?.[mappedToField]?.length) {// mappedToField == vehicleFieldsToMap.licensePlateType) {
            return questionTypes.Dropdown;
        }
        else if (vehicleDetailExtendedDate?.[mappedToField] || (mapToFieldType == vehicleDetailTypes.vehicle && mappedToField == vehicleFieldsToMap.registrationYearMonth)) {
            return questionTypes.Date
        }
        return questionTypes.Freetext;
    }

    return (
        <Grid container direction='column' spacing={2}>
            <Grid item container justifyContent="space-between" spacing={1}>
                <Grid item xs={8} >
                    <TextField
                        inputProps={{ style: { fontWeight: 'bold' } }}
                        style={{ width: '100%' }}
                        value={localQuestion}
                        label=""
                        variant="outlined"
                        placeholder="Type question text here..."
                        onChange={e => {
                            setLocalQuestion(e.target.value);
                            debouncedUpdate(e.target.value);
                        }}
                        onBlur={e => {
                            debouncedUpdate.flush(); // Immediately update on blur
                        }}
                    />
                </Grid>

                <Grid item xs={4}>
                    <QuestionTypeSelector
                        form={form}
                        question={question}
                        onChange={(newType) => onChange({
                            ...question,
                            ['questionType']: +newType,
                            ['mappedToFieldType']: undefined,
                            ['mappedToField']: undefined
                        })}
                    />
                </Grid>
                <Grid item xs={12} >
                    <Grid className={classes.elementContainer} container  >
                        {couldMapToField &&
                            <Grid item xs={6}>

                                <MapToFieldSelector
                                    form={form}
                                    question={question}
                                    mappedFieldsUsed={mappedFieldsUsed}
                                    onChange={(val) => {
                                        onChange({
                                            ...question,
                                            questionType: getQuestionType(val?.type, val.field),
                                            mappedToFieldType: val?.type,
                                            mappedToField: val?.field,
                                            mappedToImageType: getImageType(val?.type, val?.field),
                                            values: (val?.type == vehicleDetailTypes.vehicleDetailExtended && vehicleDetailExtendedValues?.[val?.field]?.map((v, index) => ({ ...v, value: v.id, order: index }))) ||
                                                (val?.type == vehicleDetailTypes.vehicle && vehicleFieldsValues?.[val?.field]?.map((v, index) => ({ ...v, value: v.name, order: index })))
                                        })
                                    }}
                                />
                            </Grid>
                        }
                        <Grid item xs={6}>
                            <MapToImageTypeSelector
                                vdExtendedLookup={vdExtendedLookup}
                                form={form}
                                question={question}
                                onChange={(val) => {
                                    onChange({
                                        ...question,
                                        mappedToImageType: val,
                                    })
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {!!QuestionComponent && <Grid item >
                <div className={classes.elementContainer}>
                    <QuestionComponent
                        question={question}
                        onFieldChange={(fieldName, fieldValue) => onChange({ ...question, [fieldName]: fieldValue })}
                        presetValues={(question?.mappedToFieldType == vehicleDetailTypes.vehicleDetailExtended && vehicleDetailExtendedValues?.[question?.mappedToField] ? vehicleDetailExtendedValues?.[question?.mappedToField] : null) ||
                            (question?.mappedToFieldType == vehicleDetailTypes.vehicle && vehicleFieldsValues?.[question?.mappedToField] ? vehicleFieldsValues?.[question?.mappedToField] : null)}
                    />
                </div>
            </Grid>}
        </Grid>
    );

};
export default memo(FormQuestion);

const QuestionTypeSelector = ({ form, question, onChange }) => {

    const classes = FormBuilderStyles();
    const questionTypes = Object.keys(questionTypeSetup).map(key => ({
        id: key,
        name: questionTypeSetup[key]?.name
    }));

    const renderOption = (option) => {
        return <Grid container spacing={1}>
            <Grid item style={{ width: '0.7em', height: '0.7em' }}>
                {questionTypeSetup[option.id]?.icon}
            </Grid>
            <Grid item style={{ marginLeft: '1.5em' }}>
                {option?.name}
            </Grid>
        </Grid>
    }

    return (
        <>{question.id ? <div className={classes.questionType}>
            {renderOption(questionTypes.find(q => q.id == question?.questionType))}
        </div> :
            <Select native={false}
                variant='outlined'
                style={{ width: '100%', background: '#E9F5FF', border: 'none' }}
                value={question?.questionType}
                onChange={e => onChange(e.target.value)}
            >
                {questionTypes?.map((q) => (
                    <MenuItem value={q.id} id={q.id}>{renderOption(q)}</MenuItem>
                ))}
            </Select>
        }</>
    )
}

const MapToFieldSelector = ({ question, onChange, mappedFieldsUsed }) => {

    const classes = FormBuilderStyles();

    const fieldsList = [{ id: { type: undefined, field: undefined }, name: 'No Mapping' }].concat(orderBy(vehicleFieldsToMapSetup, 'name')
        //For now we are not going to filter out fields that are already mapped to another question
        // ?.filter(f => {
        //     if (f?.id?.type === question?.mappedToFieldType && f?.id?.field === question?.mappedToField) return true;
        //     if (mappedFieldsUsed?.find(used => used?.field === f?.id?.field && used?.type === f?.id?.type)) {
        //         return false;
        //     }
        //     return true
        // })
    );


    let value = fieldsList?.find(q => q?.id?.type === question?.mappedToFieldType && q?.id?.field === question?.mappedToField) ?? fieldsList?.[0];

    return (
        <>
            <div className={classes.subTitle}>Map to asset data point</div>
            <DropdownFilter
                //className={classes.selectWhite}
                withTypeAhead
                native={false}
                variant='outlined'
                style={{ width: '100%', background: '#efefef', border: 'none' }}
                value={value?.id}
                defaultValue={fieldsList?.[0]?.id}
                //onChange={e => onChange(e.target.value)}
                onSelect={val => {
                    onChange(val?.id)
                }}
                values={fieldsList}
            >

            </DropdownFilter>
        </>
    )
}


const MapToImageTypeSelector = ({ question, onChange, vdExtendedLookup }) => {

    const classes = FormBuilderStyles();

    let { data: imageTypes, error: imageTypesError, isLoading: isLoadingImageTypes } = useGetImageTypesQuery();
    const hasImage = question?.includePhoto || question.questionType == questionTypes.Image;

    const values = [{ id: null, name: 'No Mapping' }, ...(imageTypes ?? [])];

    return (
        <>{
            hasImage && <div style={{ marginLeft: '1em' }}>
                <div className={classes.subTitle}>Map to image type</div>
                <DropdownFilter
                    withTypeAhead
                    native={false}
                    variant='outlined'
                    style={{ width: '100%', background: '#efefef', border: 'none' }}
                    value={question?.mappedToImageType}
                    onSelect={val => {
                        onChange(val?.id)
                    }}
                    values={values}
                >

                </DropdownFilter></div>}
        </>
    )
}
